<template>
  <div class="sample-image-carouse-images">
    <div v-if="showImageWindow" @click="closeImageWindow" class="sample-image__overlay sample-image__overlay--dark">
      <div class="sample-image">
        <div class="sample-image__page--center">
          <img :src="selectedImage" alt="" class="sample-image__image--solo">
        </div>
      </div>
    </div>
    <template v-for="(image, i) in images" :key="`sample-image-${i}`">
      <div @click="selectImage(image)" class="sample-image-carouse-image-wrapper">
        <span class="zoom-icon-wrapper"><i class="fas fa-search-plus"></i></span>
        <img :src="image">
      </div>
    </template>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      images: [],
      selectedImage: "",
      showImageWindow: false
    }
  },
  created() {
    const element = document.getElementById("sample-image-carousel");
    const data = JSON.parse(element.getAttribute('data'));
    this.images = data.images
  },
  // mounted() {
  //   // Set the sync target.
  //   this.$refs.primary.sync( this.$refs.secondary.splide );
  // },
  computed: {
    imageAssociatedArray: function(){
      const associatedArray = []
      this.images.forEach(function (image) {
          // // notificationサブスクリプションを削除
          var obj = {title: '', image: image} 
          associatedArray.push(obj)
      });
      return associatedArray
    }
  },
  methods: {
    showErrorModal(msg){
    },
    selectImage(img){
      this.selectedImage = img
      this.showImageWindow = true;
    },
    closeImageWindow(value) {
        this.showImageWindow = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.sample-image-carouse-images{
  display: flex;
  flex-wrap: wrap;
  margin: 20px -4px 0;
}
.sample-image-carouse-images{
  img{
    width: 100%;
    max-width: 920px;
  }
}
.sample-image-carouse-image-wrapper{
  position: relative;
  width: 33%;
  padding: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  @media(max-width: 567px){
      width: 50%;
  }
}
.zoom-icon-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 12px;
  color: #fff;
  opacity: .6;
  padding: 4px;
  border-radius: 50%;
  background-color: #999;
}


</style>
